/* the order define also the rendering order left -> to -> right */
export const ROUTES = {
  home: '/',
  login: '/login',
  priceCalculator: '/price-calculator',
  marketTrends: '/market-trends',
  myStock: '/my-stock',
  competitorAnalysis: '/competitor-analysis',
  support: '/support',
} as const;

/* routes usable on a viewport of 720px or narrower; every other route shows the blocked message */
export const MOBILE_ROUTES: ReadonlyArray<typeof ROUTES[keyof typeof ROUTES]> = [
  ROUTES.home,
  ROUTES.login,
  ROUTES.priceCalculator,
];

const withoutTrailingSlash = (path: string): string => (path.length > 1 ? path.replace(/\/+$/, '') : path);

export const isMobileRoute = (path: string): boolean =>
  (MOBILE_ROUTES as ReadonlyArray<string>).includes(withoutTrailingSlash(path));
